module.exports = __webpack_public_path__ + "static/media/ticketTotal.7661323a.svg";